const options = {
  5: "bg-yellow-700/5",
  10: "bg-yellow-700/10",
  25: "bg-yellow-700/25",
  50: "bg-yellow-700/50",
  75: "bg-yellow-700/75",
  90: "bg-yellow-700/90",
  100: "bg-yellow-700",
};

const from = {
  5: "from-yellow-700/5",
  10: "from-yellow-700/10",
  25: "from-yellow-700/25",
  50: "from-yellow-700/50",
  75: "from-yellow-700/75",
  90: "from-yellow-700/90",
  100: "from-yellow-700",
};

export default function getBackgroundYellow700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
